import { AutoFocusDirective } from './../directives/auto-focus.directive';
import { MaterialCardComponent } from './materials-list/material-card/material-card.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MainLayoutComponent } from '@stockcare-components/layouts/main-layout/main-layout.component';
import { AboutComponent } from '@stockcare-views/about/about.component';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { CdkTableModule } from '@angular/cdk/table';
import { MatSortModule } from '@angular/material/sort';
import { MaterialsListComponent } from './materials-list/materials-list.component';
import { SearchHeaderComponent } from './search-header/search-header.component';
import { ProgressBarLoaderComponent } from '@stockcare-shared/components/loaders/progress-bar-loader.component';
import { SpinningLoaderComponent } from '@stockcare-shared/components/loaders/spinning-loader.component';
import { ReportingFilterComponent } from './reporting-filter/reporting-filter.component';
import { PatientCardComponent } from './patient-card/patient-card.component';
import { ServiceCardComponent } from './materials-list/service-card/service-card.component';
import { PatientBasketEditItemComponent } from '@stockcare-views/patients/patient-basket/patient-basket-edit-item/patient-basket-edit-item.component';
import { BasketDialogComponent } from '@stockcare-views/patients/patient-basket/basket-dialog/basket-dialog.component';
import { TheatreCareOperatingRoomCancelChangesDialogComponent } from '@stockcare-views/theatre-care/theatre-care-operating-room-cancel-changes-dialog/theatre-care-operating-room-cancel-changes-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BasketSearchComponent } from './basket-search/basket-search.component';
import { PacksCardComponent } from './materials-list/packs-card/packs-card.component';
import { TruncatePipe } from '@stockcare-shared/pipes/truncate.pipe';
import { PackAccordionComponent } from '@stockcare-views/theatre-care/theatre-operating-room/pack-accordion/pack-accordion.component';
import { FilterPatientPipe } from '@stockcare-shared/pipes/patient-filter/patient-filter.pipe';
import { FilterMaterialPipe } from '@stockcare-shared/pipes/material-filter/material-filter.pipe';
import { GenericFilterPipe } from '@stockcare-shared/pipes/generic.filter';
import { ToLocalDatePipe } from '@stockcare-shared/pipes/to-local-date.pipe';
import { RemoveFocusDirective } from '@stockcare-shared/directives/remove-focus.directive';
import { TheatreMaterialCardComponent } from './materials-list/theatre-material-card/theatre-material-card.component';
import { NoStockDialogComponent } from './no-stock-dialog/no-stock-dialog.component';
import { CustomKeyboardComponent } from './custom-keyboard/custom-keyboard.component';
import { PinDialogComponent } from './pin-dialog/pin-dialog.component';
import { ScannerDetectDirective } from '@stockcare-shared/directives/scanner-detect.directive';
import { CreatePatientNoteComponent } from './create-patient-note/create-patient-note.component';
import { NoteCardItemComponent } from './create-patient-note/note-card-item/note-card-item.component';
import { ReadMoreComponent } from './read-more/read-more.component';
import { CreatePatientNoteDialog } from './create-patient-note/create-patient-note-dialog/create-patient-note-dialog.component';
import { SelectComponent } from './select/select.component';
import { InputComponent } from './input/input.component';
import { MatInputModule } from '@angular/material/input';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { InfoTileComponent } from './stock-counting-tiles/info-tile/info-tile.component';
import { StatTileComponent } from './stock-counting-tiles/stat-tile/stat-tile.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatGridList } from '@angular/material/grid-list';
import { ErrorConfirmationDialog } from './error-confirmation-dialog/error-confirmation-dialog.component';
import { TheatreAddPackToBasketDialog } from './theatre-add-pack-to-basket-dialog/theatre-add-pack-to-basket-dialog.component';
import { DialogConfirmDeleteComponent } from './dialog-confirm-delete/dialog-confirm-delete.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { GradientProgressBarComponent } from './gradient-progress-bar/gradient-progress-bar.component';
import { BlockProgressBarComponent } from './block-progress-bar/block-progress-bar.component';
import { InfoContainerComponent } from './info-container/info-container.component';



const components = [
  AuthLayoutComponent,
  MainLayoutComponent,
  MaterialsListComponent,
  MaterialCardComponent,
  ServiceCardComponent,
  SearchHeaderComponent,
  BasketSearchComponent,
  AboutComponent,
  AutoFocusDirective,
  ScannerDetectDirective,
  RemoveFocusDirective,
  ProgressBarLoaderComponent,
  SpinningLoaderComponent,
  ReportingFilterComponent,
  PatientCardComponent,
  PatientBasketEditItemComponent,
  BasketDialogComponent,
  TheatreCareOperatingRoomCancelChangesDialogComponent,
  PacksCardComponent,
  TruncatePipe,
  PackAccordionComponent,
  FilterPatientPipe,
  FilterMaterialPipe,
  GenericFilterPipe,
  ToLocalDatePipe,
  TheatreMaterialCardComponent,
  NoStockDialogComponent,
  CustomKeyboardComponent,
  PinDialogComponent,
  CreatePatientNoteComponent,
  NoteCardItemComponent,
  ReadMoreComponent,
  CreatePatientNoteDialog,
  SelectComponent,
  InputComponent,
  InfoTileComponent,
  StatTileComponent,
  ErrorConfirmationDialog,
  TheatreAddPackToBasketDialog,
  DialogConfirmDeleteComponent,
  ConfirmDialogComponent,
  GradientProgressBarComponent,
  BlockProgressBarComponent,
  InfoContainerComponent,

];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatDialogModule,
    MatCheckboxModule,
    MatTableModule,
    CdkTableModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSortModule,
    MatCardModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    ScrollingModule,
    MatSelectModule,
    MatTabsModule,
    MatSliderModule,
    MatTooltipModule,
    MatInputModule,
    NgApexchartsModule,
    MatTreeModule
  ],
  declarations: [
    components
  ],
  exports: [
    components,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatDialogModule,
    MatCheckboxModule,
    MatTableModule,
    CdkTableModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSortModule,
    MatCardModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    ScrollingModule,
    MatSelectModule,
    MatTabsModule,
    MatTreeModule,
    MatTabsModule
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: ['app-dialog'],
        disableClose: false,
        hasBackdrop: true,
      },
    },
  ],
})
export class SharedComponentsModule { }
